module.exports = __webpack_public_path__ + "img/zt_shl.063c605f.jpg";